import { useQuery } from '@tanstack/react-query';
import { fetchPublisherProfiles, type PublisherProfilesResponse } from '@/api/workflowCommunityPublishing.api';

export const EMPTY_PUBLISHER_PROFILES_RESPONSE: PublisherProfilesResponse = {
  profiles: [],
  is_banned_from_community_publishing: false,
  is_paid_figma_user: false,
  has_accepted_community_creator_agreement: false,
  community_user_level_creator_agreement_enabled: false,
};

export const communityPublisherProfilesQueryKey = (figmaUserId: string | null) => [
  'communityPublisherProfiles',
  figmaUserId,
];

/**
 * `figmaUserId` is no longer sent — Core resolves the user from its stored grant — but it still keys the
 * cache, so a different linked account cannot reuse the previous one's profiles, and it gates the query
 * until an account is linked.
 */
export const useCommunityPublisherProfiles = (figmaUserId: string | null, enabled = true) =>
  useQuery({
    queryKey: communityPublisherProfilesQueryKey(figmaUserId),
    queryFn: () => fetchPublisherProfiles(),
    enabled: enabled && Boolean(figmaUserId),
    staleTime: 5 * 60 * 1000,
  });
